var sessionTitle = document.querySelectorAll('.session .session-info');

for (var i = 0; i < sessionTitle.length; i++) {
    sessionTitle[i].addEventListener('click', function() {
        this.parentElement.classList.toggle('active');
    });
}